import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { getMainPlatformData } from '~/creatorUtils';
import { CreatorType } from '~/types';

interface Props extends FlexProps {
  creator?: CreatorType;
}

export const CreatorName: React.FC<Props> = ({ creator, ...props }) => {
  const { name = undefined } = creator ? getMainPlatformData(creator) : {};

  return (
    <Flex
      data-testid="creator-name"
      alignItems="center"
      color="white"
      fontWeight="medium"
      fontSize="xl"
      {...props}
    >
      <Text
        display="inline"
        maxWidth={{
          base: 36,
          lg: 72,
        }}
        noOfLines={1}
      >
        {name}
      </Text>
      <Text as="span" color="white">
        's Media Pack
      </Text>
    </Flex>
  );
};
